// Here we create a string displaying the currentdate and time.
function lastUpdatedDate(date) {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  let array = [];
  if (date.includes("/")) {
    array = date.split("/");
  } else {
    array = date.split("-");
  }

  return array[0] + " " + months[array[1] - 1] + " " + array[2];
}

export default lastUpdatedDate;
